import { identity } from 'lodash';

/**
 * @param {Object} config
 * @returns {Boolean}
 */
function isAppTrace(config) {
  return config?.url.includes('apptrace.com');
}

/**
 * @param {Object} config
 * @returns {Boolean}
 */
function isHttpGet(config) {
  return config?.method.toLowerCase() === 'get';
}

/**
 * @param {Number} status
 * @returns {Boolean}
 */
function isValidStatus(status) {
  return status && /^[1-5]\d\d$/.test(status);
}

/**
 * @param {Object} rejection
 * @param {Object} rejection.response
 * @param {Object} rejection.status
 * @returns {Promise<Object>}
 */
export const onRejected = ({response = {}} = {}) => {
  const { config, status } = response;

  if (isAppTrace(config) || !isHttpGet(config) || !isValidStatus(status)) {
    return Promise.reject(response);
  }

  if (status === 404 && !config.ignore404) {
    window.location.assign('/404.html');
  }

  if (![401, 404].includes(status) && config.critical) {
    window.location.assign('/#/error-page');
  }

  return Promise.reject(response);
};

export const onFulfilled = identity;
